module.exports = __webpack_public_path__ + "static/media/kive_logo.67794518.svg";